module.exports = ".current-node-title {\n  font-weight: bold; }\n"